var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_10716)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4829 1.17149C20.8626 0.469045 22.3948 0.112427 24.2243 0.112427H32.2873L30.7715 2.37817C31.1454 2.7413 31.4445 3.16491 31.6672 3.57385C31.9879 4.16278 32.2043 4.82202 32.2043 5.34545V15.8219L30.1712 17.8789L26.4007 15.9715V14.4302L24.8891 13.35C23.4451 12.3855 22.8894 11.0286 22.8894 9.90325C22.8894 9.42479 23.0211 8.88896 23.2487 8.39977C23.4775 7.90823 23.8271 7.41262 24.3078 7.05273L25.1709 8.23268C24.9262 8.41591 24.7135 8.69828 24.5614 9.02508C24.4082 9.35424 24.3404 9.67712 24.3404 9.90325C24.3404 10.5367 24.6525 11.4365 25.6963 12.1302L25.7065 12.137L27.8516 13.6699V15.0643L29.8847 16.0928L30.7534 15.2139V5.34545C30.7534 5.1643 30.6543 4.75565 30.3964 4.28219C30.1465 3.82319 29.7998 3.40163 29.4042 3.1449L28.7782 2.73874L29.5532 1.58032H24.2243C22.5934 1.58032 21.289 1.89526 20.1351 2.48272C18.9738 3.07394 17.9265 3.96065 16.8362 5.15977L16.8104 5.18811L16.7819 5.21356C16.6714 5.31207 16.5631 5.40882 16.4568 5.50379C15.2424 6.58902 14.2894 7.44074 13.2489 8.00878C12.0713 8.65176 10.8162 8.91977 8.98965 8.91977H2.46777V7.45188H8.98965C10.6598 7.45188 11.6573 7.20979 12.5599 6.71699C13.4467 6.23279 14.2733 5.49504 15.5487 4.35669C15.6287 4.28521 15.7106 4.21216 15.7943 4.13748C16.9447 2.87648 18.1207 1.86496 19.4829 1.17149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.414 6.70448C19.0544 7.1114 18.6565 7.56164 18.1882 7.98933C17.9765 8.18275 17.7593 8.39645 17.532 8.6202C16.8923 9.24987 16.1717 9.95912 15.2621 10.5199C13.9723 11.3151 12.2892 11.8482 9.72202 11.8482H6.09473V10.3803H9.72202C12.0735 10.3803 13.4844 9.89693 14.507 9.26645C15.2673 8.79772 15.8121 8.2613 16.4116 7.67104C16.6634 7.42312 16.9248 7.16569 17.2159 6.89979C17.6259 6.52534 17.9791 6.12573 18.3509 5.70513L18.363 5.69144C18.7304 5.2757 19.1227 4.83253 19.5724 4.44013C20.5133 3.61927 21.6821 3.04089 23.5057 3.04089V4.50878C22.0503 4.50878 21.2132 4.94692 20.52 5.55175C20.1527 5.87219 19.8208 6.24416 19.4445 6.66993L19.414 6.70448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7966 8.6975L27.3457 7.22961L28.3717 6.19165L29.8226 7.65954L28.7966 8.6975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.549 13.3162C12.7745 13.3162 14.6826 12.7225 16.5782 11.4624L17.3749 12.6892C15.2515 14.1007 13.068 14.7841 10.549 14.7841H0.291016V13.3162H10.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3161 16.8008C21.9711 15.0797 22.4931 13.303 23.7185 12.0632L24.7445 13.1012C23.8663 13.9896 23.4887 15.2659 23.7382 16.5096L23.7385 16.5111C23.9561 17.6074 23.8623 18.5117 23.4789 19.3311C23.2198 19.885 22.8416 20.3691 22.4046 20.8276L28.4836 26.1099L29.3927 28.8691L26.9883 32.1125L25.8275 31.2318L27.7758 28.6036L27.234 26.9591L20.2393 20.8811L20.8374 20.322C21.4945 19.7078 21.9253 19.2208 22.1675 18.7031C22.3953 18.2162 22.4829 17.6418 22.3161 16.8008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9657 23.6333L9.50935 20.1366L8.4834 21.1746L12.2817 25.0173L17.4475 25.7639L22.5617 28.9976L21.4058 31.3365L22.7035 31.993L24.4494 28.4603L17.9563 24.3546L12.9657 23.6333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_10716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.291016 0.105103)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/hp.bc7f735da8e695450f9b469f1c873edc.svg";
export { ForwardRef as ReactComponent };